import { dateRangeSchema, paginationFiltersSchema } from 'utils/schemas';
import { z } from 'zod';
import { claimMismatches, claimStatuses } from './claims.types';

export const claimsFiltersSchema = z
  .object({
    mismatch: z.array(z.enum(claimMismatches)).catch([]),
    company: z.array(z.string()).catch([]),
    benefit: z.array(z.string()).catch([]),
    status: z.array(z.enum(claimStatuses)).catch([]),
    claimDate: dateRangeSchema,
    purchaseDate: dateRangeSchema,
    search: z.string().catch(''),
  })
  .merge(paginationFiltersSchema);
